import { render, staticRenderFns } from "./AdminAreaDropdown.vue?vue&type=template&id=72b5bb1d&scoped=true"
import script from "./AdminAreaDropdown.vue?vue&type=script&lang=js"
export * from "./AdminAreaDropdown.vue?vue&type=script&lang=js"
import style0 from "./AdminAreaDropdown.vue?vue&type=style&index=0&id=72b5bb1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b5bb1d",
  null
  
)

export default component.exports